import { up } from 'styled-breakpoints'
import styled from 'styled-components'

import theme from '~/truck/theme'

import Modal from '../modal'

export const ModalContainer = styled(Modal)`
  border-radius: ${theme.spacing.compact}px;
  box-shadow:
    0px 16px 24px rgba(0, 0, 0, 0.14),
    0px 6px 30px rgba(0, 0, 0, 0.12),
    0px 8px 10px rgba(0, 0, 0, 0.2);
  height: auto;
  left: 50%;
  max-width: ${theme.spacing.cozy * 45}px;
  overflow-y: hidden;
  padding: ${theme.spacing.relaxed}px;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 95%;

  ${up('md')} {
    max-width: ${theme.spacing.cozy * 62}px;
    width: auto;
  }
`
